<div fxLayout="column" fxLayoutAlign="center center" fxFlexFill class="lighten fa-layers">
   <fa-icon [icon]="noValidConfigIcon" size="2x"></fa-icon>
</div>
